import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Table from '../../components/Table';
import Loader from '../../components/Loader';
import translations from '../../translations/de';
import API from '../../api/passes.js';
import { useHistory } from 'react-router-dom';
import { FaSearch, FaUndoAlt, FaCheck, FaTimes } from 'react-icons/fa';
import Button from '../../components/Button';
import InputSeason from '../../components/InputSeason/InputSeason';

const Tickets = ({ fanID }) => {
    const [loader, setLoader] = useState(false);
    const [passes, setPasses] = useState([]);
    const history = useHistory();
    const [selectedSeason, setSelectedSeason] = useState(
        history?.location?.state?.selectedSeason ?? null,
    );

    const handlePass = (e) => {
        history.push(`/abos/${e}`);
    };

    const isNotDeletedAlready = (row) => {
        return !row.original.deleted_at;
    };

    const revivePass = (id) => {
        try {
            API.revivePass(id);
            const initialState = passes.map((pass) => {
                if (pass?.id === id) {
                    return { ...pass, deleted_at: null };
                }
                return pass;
            });
            setPasses(initialState);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        setLoader(true);
        const getPasses = async () => {
            try {
                const res = await API.getPassesFromFanID(fanID, {
                    params: { limit: 50, season_id: selectedSeason },
                });
                setPasses(res.data.items);
                setLoader(false);
            } catch (e) {
                console.log(e);
                setLoader(false);
            }
        };

        selectedSeason && getPasses();
    }, [fanID, selectedSeason]);

    useEffect(() => {
        return history.listen(() => {
            if (history.action === 'POP') {
                history.replace({ pathname: '/fans' });
            }
        });
    }, [history]);

    return (
        <>
            <div>
                {
                    <div className="tab-controls">
                        <div style={{ display: 'block' }}>
                            <InputSeason
                                selectedSeason={selectedSeason}
                                setSelectedSeason={setSelectedSeason}
                            />
                        </div>
                    </div>
                }

                {loader ? (
                    <div className="loader-wrapper">
                        <Loader size="big" theme="dark" />
                    </div>
                ) : passes.length !== 0 ? (
                    <Table
                        isRowClickable={false}
                        columns={[
                            {
                                Header: 'ID',
                                accessor: 'id',
                                Cell: ({ value }) => <div>{value}</div>,
                            },
                            {
                                Header: 'Ticket-Nr',
                                accessor: 'ticket_id',
                                Cell: ({ value }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.assign_token,
                                accessor: 'assign_token',
                                Cell: ({ value }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.name,
                                accessor: 'name',
                                Cell: ({ value }) => <div>{value}</div>,
                            },
                            {
                                Header: translations.can_claim_freunde,
                                accessor: 'can_claim_freunde',
                                Cell: ({ value }) => (
                                    <div>
                                        {value === true ? (
                                            <FaCheck className="confirm" />
                                        ) : (
                                            <FaTimes className="error" />
                                        )}
                                    </div>
                                ),
                            },
                            {
                                Header: translations.seat,
                                accessor: 'seat',
                                // A Fründe-Ticket carries no seat at all, so
                                // every step here has to tolerate null - this
                                // threw and took the whole Fan page down.
                                Cell: ({ value }) => (
                                    <div>
                                        Entrance: {value?.seat_group?.sector?.title} <br />
                                        Block: {value?.seat_group?.title} <br />
                                        Row: {value?.row} <br />
                                        Seat: {value?.num} <br />
                                    </div>
                                ),
                            },
                            {
                                Header: '',
                                accessor: 'action',
                                Cell: ({ row }) => (
                                    <div className="button-cell">
                                        <Button
                                            onClick={() => {
                                                handlePass(row.cells[0].value);
                                            }}
                                            title={translations.show}
                                        >
                                            <FaSearch />
                                        </Button>

                                        {/* Abos come from Tixx and are only mirrored here. Deleting one
                                            in this panel hid it from us while it stayed alive at Tixx, and a
                                            soft-deleted access is never recreated — the ticket simply became
                                            invisible. Deletion belongs in the Tixx panel. Revive stays, for
                                            rows deleted before this. */}
                                        {!isNotDeletedAlready(row) && (
                                            <Button onClick={() => revivePass(row.cells[0].value)}>
                                                <FaUndoAlt />
                                            </Button>
                                        )}
                                    </div>
                                ),
                            },
                        ]}
                        data={passes.map(
                            ({
                                id,
                                ticket_id,
                                assign_token,
                                first_name,
                                last_name,
                                seat,
                                can_claim_freunde,
                                deleted_at,
                            }) => {
                                return {
                                    id,
                                    ticket_id,
                                    assign_token,
                                    name: first_name + ' ' + last_name,
                                    seat,
                                    can_claim_freunde,
                                    deleted_at,
                                };
                            },
                        )}
                    ></Table>
                ) : (
                    <p className="no-itmes">No data yet!</p>
                )}
            </div>
        </>
    );
};

export default observer(Tickets);
